import { EXPERIAN_FORM }  from "../constants";

const initialState = {}

const VerifyExperianReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case EXPERIAN_FORM.VERIFY_EXPERIAN_DETAILS:
            return {
                 ...payload
             }
        case EXPERIAN_FORM.VERIFY_EXPERIAN_SUCCESS:
            return {
                ...payload
            }
        case EXPERIAN_FORM.VERIFY_EXPERIAN_FAIL:
            return {
                ...payload
            }
               
        default:
            return state;
    }
}

export default VerifyExperianReducer;